import React, { FC, useMemo } from 'react';
import cx from 'classnames';

import { useAppSelector } from 'store/hooks';
import { PortalConfigSelector } from 'store/config/selectors';
import { UserRoleSelector } from 'store/user/selector';

import SideBarItem from './SideBarItem';

import { sideBarItems } from '../constants';
import { LOCAL_STORAGE_PSA } from 'constants/storage';
import { SideBarItemTypes } from '../types';

import useStyles from '../styles';

const SideBar: FC = () => {
  const classes = useStyles();
  const config = useAppSelector(PortalConfigSelector);
  const role = useAppSelector(UserRoleSelector);

  const items = useMemo(() => {
    if (role) {
      let items = sideBarItems;
      // If chats are disabled in the config, remove the item with the id "chats".
      if (config.disableChats) {
        items = sideBarItems.filter(i => i.id !== SideBarItemTypes.Chats);
      }

      return items.filter(i => {
        const isHasRole = i.roles.includes(role);
        // Show the "Invoices" item only if PSA is set to "Connectwise" and the user has the required role.
        if (i.id === SideBarItemTypes.Invoices) {
          return localStorage.getItem(LOCAL_STORAGE_PSA) === 'Connectwise' && isHasRole;
        }
        return isHasRole;
      });
    } else {
      return [];
    }
  }, [config, role]);

  return (
    <div className={cx(classes.sidebar)}>
      <div className={classes.sidebarLogo}>{config.logo && <img src={config.logo} alt={config.caption} />}</div>
      <div className={classes.sidebarItems}>
        {items.map(i => (
          <SideBarItem {...i} key={i.title} />
        ))}
      </div>
    </div>
  );
};

export default SideBar;
